import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import RegistrationForm from 'components/common/RegistrationForm'
import FeaturesSideBySide from 'components/features/FeaturesSideBySide'
import MaltaFeatures from 'components/features/MaltaFeatures'
import Team from 'components/team/Team'
import Pricing from 'components/pricing/AdvisorPricing'
import Testimonials from 'components/testimonials/Testimonials'
import Security from 'components/security/Security'


import MaltaFlag from 'assets/flags/malta.svg';

import rosemontLogo from 'assets/images/accountants/rosemont.png';
import finanziLogo from 'assets/images/accountants/finanzi.png';
import taxeaLogo from 'assets/images/accountants/taxea.png';
import accountantsFade from 'assets/images/accountants/accountants.jpg';


import PayslipSampleGenerator from 'components/common/PayslipSampleGenerator'
import TimelineExample from 'components/common/TimelineExample'


function Home({

}) {


  return (

    <React.Fragment>

      <Helmet>
          <title>Payroll for Accountants &amp; CSPs - Buddy HR</title>
        <meta name="description" content="Find answers to the most frequently asked questions about payroll, including calculating payroll, employee leave, tax and benefits deductions." />
          <link rel="canonical" href={`https://www.buddy.hr/childcare-payroll`} />
      </Helmet>
      <main className="pt-8 sm:pt-16 md:pt-20 lg:pb-24 pb-8 sm:pb-16 md:pb-20 lg:pb-24"
          style={{
            backgroundImage: `url(${accountantsFade})`,
            backgroundPosition: "center center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  <span className="text-orange-400">Payroll Software for Accountants</span>
                  <br className="hidden md:inline"/>
                  <span className="text-3xl sm:text-5xl lg:text-4xl xl:text-5xl">and Payroll Bureaus</span>
                </h1>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Buddy sets your Payroll Service apart.
                  An easy to use, yet powerful payroll software that saves you time with highly-scalable pricing.
                </p>
                <p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-15 sm:h-20 filter brightness-200 contrast-50 grayscale hover:filter-none" src={rosemontLogo} alt="Mc Donalds"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-15 sm:h-20 filter brightness-200 contrast-50 grayscale hover:filter-none" src={finanziLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-15 sm:h-20 filter brightness-200 contrast-50 grayscale hover:filter-none" src={taxeaLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
              <RegistrationForm/>
            </div>
          </div>
        </div>
      </main>

      <div className="bg-white">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-gray-900">You continously face these Payroll Challenges</h2>
            {/*<p className="mt-4 text-lg text-gray-500">Time is the most prescious resource for people like yourselves; and you probably find that it ends up consumed by:</p>*/}
          </div>
          <dl className="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Collecting Information</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Clients have to send emails with papers or excel sheets full of information.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Tallying Timesheets</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                You have to tally up hours from your excel timesheets to calculate overtime pay and other variables.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Chase Leave Data</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Chase clients for monthly leave to ensure that they have legally compliant payslips.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Mantaining Excel Sheets</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Pro-rata employees require complex computations that you currently manage outside your payroll software.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Changing Regulations</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Tax, social security, benefits, leave regulations, COVID-19 Supplement...
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Payslip Questions</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Clients &amp; their employees are always querying or doubting the payslips and how the numbers add up.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Client Requests</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Requests for lost payslips, leave balances, FS3s, updating of details... all eat into your time.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">FSS Submission Nightmares</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                You dread the year-end submission process of having to generate and fix the submission files manually.
              </dd>
            </div>
          </dl>
          <div className="text-6xl text-center mt-15">🤯</div>
        </div>
      </div>



      <div id='features' className="py-16 bg-gray-50 overflow-hidden lg:py-24">
        <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-screen-xl">
          <svg className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4" width="404" height="784" fill="none" viewBox="0 0 404 784">
            <defs>
              <pattern id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect width="404" height="784" fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
          </svg>

          <div className="relative">
            <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
              A better way to do payroll for clients
            </h3>
            <p className="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-gray-500">
              Buddy's feature-rich and easy-to-use payroll solution, gives you all the tools you need.
            </p>
          </div>

          <div className="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="relative">
              <h4 className="text-2xl leading-8 font-extrabold text-gray-900 tracking-tight sm:text-3xl sm:leading-9">
                World-class time-saving features
              </h4>
              <p className="mt-3 text-lg leading-7 text-gray-500">
                Payroll can be a time-consuming and stressful experience. 
                Buddy doesn't only take care of your payroll calculations but seeks to simplify your payroll processes.
              </p>

              <ul className="mt-10">
                <li>
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: globe-alt */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Instant Calculations &amp; Payslip Previews</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Our payroll process allows you instantly edit and view draft payslips as you're working on your payroll.
                        Reducing the likelyhood of mistakes and payroll complications.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: lightning-bolt */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Time &amp; Attendance Rule Engine</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Buddy's time and attendance rule engine allows you to easily convert client timesheets into payroll data.
                        Rules can be customised to for each clients' requirements.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: scale */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">IBAN Transfers</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Speed up your payments by generating bank payment files. All SEPA compliant banks are supported.
                        No matter how many employees a calient may have have issuing payments becomes lightning fast.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: scale */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Audit Trail</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        With clients changing their minds on a regular basis, it's critical to have a detailed audit-trail for all updates in the system.
                        Hence enabling you to go back and find out when and why details have changed.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="mt-10">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        {/* Heroicon name: scale */}
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                        </svg>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h5 className="text-lg leading-6 font-medium text-gray-900">Touch-free Payroll</h5>
                      <p className="mt-2 text-base leading-6 text-gray-500">
                        Coming-soon. Have numerous clients with Fixed pay? Or where your direct input is not required?
                        Our Touch-free payroll will auto-generate payroll drafts, and send payslips to your clients and employees automatically unless you manually intervene.
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-10 -mx-4 relative lg:mt-0">
              <PayslipSampleGenerator/>
              {/*<img className="relative mx-auto" width="490" src="https://tailwindui.com/img/features/feature-example-1.png" alt=""/>*/}
            </div>
          </div>

          <svg className="hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12" width="404" height="784" fill="none" viewBox="0 0 404 784">
            <defs>
              <pattern id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect width="404" height="784" fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" />
          </svg>

          <div className="relative mt-12 sm:mt-16 lg:mt-24">
            <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="lg:col-start-2">
                <h4 className="text-2xl leading-8 font-extrabold text-gray-900 tracking-tight sm:text-3xl sm:leading-9">
                  Empower your Clients
                </h4>
                <p className="mt-3 text-lg leading-7 text-gray-500">
                  Access to Buddy's portal gives improved security and visibility to your clients and their employees.
                  At the same time saving valuable admin time
                </p>

                <ul className="mt-10">
                  <li>
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          {/* Heroicon name: annotation */}
                          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <h5 className="text-lg leading-6 font-medium text-gray-900">Employee Data</h5>
                        <p className="mt-2 text-base leading-6 text-gray-500">
                          Allow clients to insert and update Employee Data directly into Buddy, so you don't have to duplicate the effort.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-10">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          {/* Heroicon name: annotation */}
                          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <h5 className="text-lg leading-6 font-medium text-gray-900">Payslip Access</h5>
                        <p className="mt-2 text-base leading-6 text-gray-500">
                          Clients &amp; Employees can access their easy-to-understand payslips securely through the portal at any time. From their mobile phone or pc.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-10">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          {/* Heroicon name: mail */}
                          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <h5 className="text-lg leading-6 font-medium text-gray-900">Vacation Management</h5>
                        <p className="mt-2 text-base leading-6 text-gray-500">
                          Employees can apply for vacation leave and view their balances at any time.
                          Whilst clients &amp; their managers get instant email notifications and can approve vacation at their convenience.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-10">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          {/* Heroicon name: mail */}
                          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                        </div>
                      </div>
                      <div className="ml-4">
                        <h5 className="text-lg leading-6 font-medium text-gray-900">Time &amp; Attendance (Remote or In-Person)</h5>
                        <p className="mt-2 text-base leading-6 text-gray-500">
                          Employees can track their hours via the Employee portal.
                          Otherwise you can connect with other punch-clock systems for accurate in-person tracking.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1">
                <svg className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden" width="784" height="404" fill="none" viewBox="0 0 784 404">
                  <defs>
                    <pattern id="e80155a9-dfde-425a-b5ea-1f6fadd20131" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                      <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                    </pattern>
                  </defs>
                  <rect width="784" height="404" fill="url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)" />
                </svg>
                <TimelineExample/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MaltaFeatures/>

      <div className="py-12 bg-orange-500">
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-screen-xl lg:px-8">

          <div className="relative">
            <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl sm:leading-10">
             { /*<img className="h-9 sm:h-10" src={MaltaFlag} alt="Maltese Flag"/> */}
              You'll also love these
            </h3>
            <p className="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-gray-300">
              
            </p>
          </div>

          <div className="lg:grid lg:grid-cols-3 lg:gap-8 relative mt-12 lg:mt-24 ">
            <div>
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-gray-800 text-white">
                {/* Heroicon name: globe-alt */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Team Management</h5>
                <p className="mt-2 text-base leading-6 text-gray-100">
                  Easily control team access from your advisor portal.
                  Each of your team members will have separate credentials for utmost secuity.
                </p>
              </div>
            </div>
            <div>
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-gray-800 text-white">
                {/* Heroicon name: globe-alt */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Client Management</h5>
                <p className="mt-2 text-base leading-6 text-gray-100">
                  Your advisor portal will give you a bird's eye view on all your clients.
                  Including when you last completed payroll for each client and their upcoming deadlines.
                </p>
              </div>
            </div>
            <div className="mt-10 lg:mt-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-gray-800 text-white">
                {/* Heroicon name: scale */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Portability</h5>
                <p className="mt-2 text-base leading-6 text-gray-100">
                  Does payroll block your team from working remotely? Not anymore.
                  Being cloud-based Buddy allows your team to work from anywhere.
                </p>
              </div>
            </div>
            <div className="mt-10 lg:mt-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-gray-800 text-white">
                {/* Heroicon name: scale */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Integrations</h5>
                <p className="mt-2 text-base leading-6 text-gray-100">
                  Buddy talks with other software that have open APIs. Including Xero and Deputy.
                  Hence we can send payroll data directly to your accounting software.
                </p>
              </div>
            </div>
            <div className="mt-10 lg:mt-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-gray-800 text-white">
                {/* Heroicon name: lightning-bolt */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Legal Updates Included</h5>
                <p className="mt-2 text-base leading-6 text-gray-100">
                  Changes in law or tax brackets are updated by our team so can't get them wrong.
                </p>
              </div>
            </div>
            <div className="mt-10 lg:mt-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-gray-800 text-white">
                {/* Heroicon name: lightning-bolt */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Easy Reporting</h5>
                <p className="mt-2 text-base leading-6 text-gray-100">
                  Pre-set PDF and Excel based reports available at your fingertips. 
                  That way you don't have to spend hours compiling client reports.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pricing/>
      <Testimonials/>
      <Security/>
      <Team/>

      <div className="bg-orange-600">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
            <span className="block">Forget your payroll pains.</span>
            <span className="block">Book a FREE Consult today.</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-orange-200">Talk to one of our payroll experts <br/>and see how you can improve your payroll process.</p>
          <a href="https://calendly.com/buddy-intro/buddy-introduction-meeting" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
            Book my spot
          </a>
        </div>
      </div>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home) 
